import React, { useState } from "react";
import { useLanguage } from "./LanguageContext"; // Assuming this hook provides currentLanguage

const BookingForm = () => {
  const [status, setStatus] = useState("sendMessage");
  const { currentLanguage } = useLanguage(); // Access the current language from context

  // Translation dictionary
  const t = (key) => {
    const dict = {
      sending: {
        en: "Sending...",
        fr: "Envoi en cours...",
        de: "Wird gesendet...",
        es: "Enviando...",
      },
      sendMessage: {
        en: "Send us your message",
        fr: "Envoyez-nous votre message",
        de: "Senden Sie uns Ihre Nachricht",
        es: "Envíenos su mensaje",
      },
      firstName: {
        en: "First Name",
        fr: "Prénom",
        de: "Vorname",
        es: "Nombre",
      },
      lastName: {
        en: "Last Name",
        fr: "Nom de famille",
        de: "Nachname",
        es: "Apellido",
      },
      email: {
        en: "Email",
        fr: "Email",
        de: "E-Mail",
        es: "Correo electrónico",
      },
      phone: {
        en: "Phone Number",
        fr: "Numéro de téléphone",
        de: "Telefonnummer",
        es: "Número de teléfono",
      },
      company: {
        en: "Company",
        fr: "Société",
        de: "Firma",
        es: "Empresa",
      },
      message: {
        en: "How can we help you?",
        fr: "Comment pouvons-nous vous aider ?",
        de: "Wie können wir Ihnen helfen?",
        es: "¿Cómo podemos ayudarte?",
      },
    };

    return dict[key][currentLanguage];
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(t("sending"));
    const formData = new FormData(e.target);
    const details = {
      firstName: formData.get("firstName"),
      lastName: formData.get("lastName"),
      email: formData.get("email"),
      phone: formData.get("phone"),
      company: formData.get("company"),
      message: formData.get("message"),
    };

    try {
      const response = await fetch("http://localhost:5000/bookdemo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify(details),
      });
      setStatus(t("sendMessage"));
      const result = await response.json();
      if (response.ok) {
        alert(result.status);
      } else {
        throw new Error(result.message);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to send message. Please try again later.");
    }
  };

  return (
    <form action="./mailer.php" method="POST" onSubmit={handleSubmit}>
      <div className="form-input-container">
        <div className="singular-input-container">
          <label htmlFor="firstName">{t("firstName")}</label>
          <input type="text" id="firstName" name="firstName" required />
        </div>
        <div className="singular-input-container">
          <label htmlFor="lastName">{t("lastName")}</label>
          <input type="text" id="lastName" name="lastName" required />
        </div>
      </div>
      <div className="form-input-container">
        <div className="singular-input-container">
          <label htmlFor="email">{t("email")}</label>
          <input type="email" id="email" name="email" required />
        </div>
        <div className="singular-input-container">
          <label htmlFor="phone">{t("phone")}</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            pattern="[0-9]{10}"
            required
          />
        </div>
      </div>
      <div className="form-input-container-full">
        <label htmlFor="company">{t("company")}</label>
        <input type="text" id="company" name="company" required />
      </div>
      <div className="form-input-container-full">
        <label htmlFor="message">{t("message")}</label>
        <textarea id="message" name="message" required></textarea>
      </div>
      <button className="cta-button-large-careers" type="submit">
        {t(status)}
      </button>
      <input type="hidden" name="subject" />
    </form>
  );
};

export default BookingForm;
